const SUBSCRIPTION_API = 'https://api.jashsoft.com/pay/subscription';

class GetSubscription {
  action(modelInstance) {
    return fetch(SUBSCRIPTION_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerEmail: modelInstance.emailAddress
      })
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Subscription request failed');
      }
      return response.json();
    });
  }
}

export default GetSubscription;
